import { FormattedMessage } from 'react-intl';
import styles from './TextWithIcon.module.css';
import classNames from 'classnames';

export const TextWithIcon = ({
    className,
    icon,
    messageObject,
    values
}: {
    className?: string | null;
    icon: JSX.Element;
    messageObject: {
        id: string;
        defaultMessage: string;
    };
    values?: {
        amount: JSX.Element;
        date: JSX.Element;
        unableToPayLink: JSX.Element;
    };
}) => {
    const customParentStyles = classNames(styles.TextWithIcon, className);
    const customIconStyles = classNames(styles.icon, className);

    return (
        <div data-testid="status-line-text" className={customParentStyles}>
            <span className={customIconStyles}>{icon}</span>
            <span className={styles.text}>
                <FormattedMessage {...messageObject} values={values} />
            </span>
        </div>
    );
};
